import { Injectable, Injector } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MicrosoftApplicationInsightsService {

  constructor(private injector: Injector, private _applicationInsights: ApplicationInsights) { }


  /**
   * Función para registrar todos los errores que ocurran en el aplicativo
   */
  logError(error: Error,  url:string, stack?: string) {
    const appInsights = this.injector.get(ApplicationInsights);
    appInsights.trackException({ exception: error, properties:{
      url:url
    }});
    appInsights.flush() // Envia todos los errores a telemetry aun que estan en buffer
    environment.DEBUG_LOG && console.error('MicrosoftApplicationInsightsService: ',error);
  }


  /**
   * Función para registrar las entradas a cada una de las vistas
   */
  tracePage(name: string, user:any ){
    this._applicationInsights.trackPageView({name: name ,properties: {
      fullName: user ? user.fullName:null,
      email: user ? user.email:null,
      uid: user ? user.uid:null
    }});
  }


  /**
   * Función para registrar los eventos de cierre de sesión fallidos que ocurran en el aplicativo
   */
  trackEvent(name:string, error:any) {
    this._applicationInsights.trackEvent({name: name ,properties: {
      error: error
    }});
  }

   /**
   * Función para registrar eventos de inicio y cierre de sesión que ocurran en el aplicativo
   */
  trackSession(name:string, user:any) {
    this._applicationInsights.trackEvent({name: name ,properties: {
      fullName: user.fullName,
      email: user.email,
      uid: user.uid
    }});
  }
}
